import groq from 'groq'

export const getShopItemsGroq = groq`{
  "crib": *[_type == "shopItems" && inventory == 'crib'] {
    sku,
    "name":name[$language],
    "description":description[$language],
    isFeatured,
    isAvailable,
    requiredRank,
    isSpecialItem,
    comingSoon,
    requiredRank,
    isAvailable,
    inventory,
    itemType,
    "itemSize": itemSize->evolution,
    imageUrls[],
    price,
    durability,
    totalUpgradeTiers,
    upgradesPriceFactor,
    upgrades[]{
        upgradeType,
        valueTiers[],
    },
  },
  "dragon": *[_type == "shopItems" && inventory == 'dragon' && itemSize->evolution==$evolution] {
    sku,
    "name":name[$language],
    "description":description[$language],
    isFeatured,
    isSpecialItem,
    isAvailable,
    requiredRank,
    comingSoon,
    inventory,
    itemType,
    "itemSize": itemSize->evolution,
    imageUrls[],
    price,
    durability,
    totalUpgradeTiers,
    upgradesPriceFactor,
    upgrades[]{
        upgradeType,
        valueTiers[],
    },
  }
}`
